import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import dateFormat from 'dateformat';
import { Button, Col, Collapse, Row } from 'reactstrap';
import { MORE_INFO, APPLIED_TRADE_IN } from 'site-modules/shared/constants/appraisal/appraisal';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { OdometerPaymentValue } from 'site-modules/shared/components/car-buying/odometer-payment-value/odometer-payment-value';

export function AppraisalReportStepAppliedTradeIn({
  appliedTradeIn = 0,
  infoMessage = '',
  skipMoreInfo = false,
  className = '',
  classNameValue = '',
  hideAppraisalDate = false,
}) {
  const [isMoreInfoCollapsed, toggleMoreInfo] = useToggle();
  const [today] = useState(() => dateFormat(Date.now(), 'shortDate'));

  return (
    <Row className={classNames('trade-in', { 'mt-1_25': !skipMoreInfo })}>
      <Col xs={8} className={classNames('text-gray-darker fw-bold', className)}>
        <span>{APPLIED_TRADE_IN.title}</span>
      </Col>
      <Col xs={4} className={classNames('fw-bold text-end', classNameValue)}>
        <OdometerPaymentValue value={appliedTradeIn} />
        {!hideAppraisalDate && <div className="appraisal-date fw-normal mt-0_25 me-0_5">As of {today}</div>}
      </Col>
      {!skipMoreInfo && (
        <Col>
          <Button
            color="link"
            aria-describedby="payoff-amount"
            aria-expanded={!isMoreInfoCollapsed}
            className="p-0 mt-0_25 text-decoration-none text-start heading-6 fw-normal"
            onClick={toggleMoreInfo}
          >
            <div className="text-primary-darker">
              <span>{MORE_INFO.title}</span>
              <span
                className={classNames('ps-0_25 small text-primary-darker', {
                  'icon icon-arrow-down2': !isMoreInfoCollapsed,
                  'icon icon-arrow-up2': isMoreInfoCollapsed,
                })}
                aria-hidden
              />
            </div>
          </Button>
          <Collapse className="mt-0_75" aria-hidden={isMoreInfoCollapsed} isOpen={isMoreInfoCollapsed}>
            <p className="text-gray-darker">{MORE_INFO.APPLIED_TRADE_IN}</p>
          </Collapse>

          {infoMessage && (
            <div className="mt-0_75 small text-gray-darker" data-test="applied-trade-in-info-message">
              {infoMessage}
            </div>
          )}
        </Col>
      )}
    </Row>
  );
}

AppraisalReportStepAppliedTradeIn.propTypes = {
  appliedTradeIn: PropTypes.number,
  infoMessage: PropTypes.string,
  skipMoreInfo: PropTypes.bool,
  className: PropTypes.string,
  classNameValue: PropTypes.string,
  hideAppraisalDate: PropTypes.bool,
};
